import { ApiMenuReadMenuItemDto, MenuActionType, MenuContentLayout, type MenuId } from '@/venit/services/model/techpubs-cms';

export default class MenuUtils {
  static userRootMenuId(): MenuId {
    return {
      id: 0,
    };
  }

  static isEditableMenu(item: ApiMenuReadMenuItemDto): boolean {
    return item.id > 0;
  }

  static hasEditableChildren(item: ApiMenuReadMenuItemDto): boolean {
    return item.id > 0 && (item.actionType == MenuActionType.MENU || item.actionType == MenuActionType.MENU_TEMPLATE_ROOT);
  }

  static isTreeMenu(item: ApiMenuReadMenuItemDto): boolean {
    if (item.actionType == MenuActionType.MENU_TEMPLATE_ROOT) {
      return true;
    }
    return item.actionType == MenuActionType.MENU && item.contentLayout == MenuContentLayout.TREE;
  }

  static isTableContent(item: ApiMenuReadMenuItemDto): boolean {
    return (
      (item.actionType == MenuActionType.FILTER || item.actionType == MenuActionType.MENU) && item.contentLayout == MenuContentLayout.TABLE
    );
  }

  static isCardsContent(item: ApiMenuReadMenuItemDto): boolean {
    return (
      (item.actionType == MenuActionType.FILTER || item.actionType == MenuActionType.MENU) && item.contentLayout == MenuContentLayout.CARDS
    );
  }

  static shouldShowAsDialogWithContent(item: ApiMenuReadMenuItemDto): boolean {
    if (
      item.actionType == MenuActionType.FILE ||
      item.actionType == MenuActionType.CORTONA_MODEL ||
      item.actionType == MenuActionType.MENU_RESOURCE
    ) {
      return true;
    }
    return false;
  }

  static shouldOpenInMainArea(item: ApiMenuReadMenuItemDto): boolean {
    return (
      item.actionType == MenuActionType.FILTER || (item.actionType == MenuActionType.MENU && item.contentLayout != MenuContentLayout.TREE)
    );
  }
}
